import { useEffect } from 'react'

import { fetchBootstrap } from 'conversations/modules/bootstrap/api'
import { fetchTags } from 'conversations/modules/conversation/api'
import { fetchBans } from 'conversations/modules/endUser/api'
import { fetchRules } from 'conversations/modules/rules/api'
import { fetchTeams } from 'conversations/modules/teams/api'
import { fetchPreferences, fetchUsers } from 'conversations/modules/user/api'
import { getNotificationsBySection } from 'conversations/modules/user/sections/api'
import { getOrgId } from 'conversations/modules/user/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBootstrapAsync } from 'shared/store/actions/bootstrap'
import { fetchTagsAsync } from 'shared/store/actions/conversation'
import { fetchBansAsync } from 'shared/store/actions/endUser'
import { fetchRulesAsync } from 'shared/store/actions/rules'
import { fetchTeamsAsync } from 'shared/store/actions/teams'
import {
  fetchNotificationSettingsBySubscription,
  fetchPreferencesAsync,
  fetchUsersAsync,
} from 'shared/store/actions/user'
import { fetchSectionsSubscriptionsAsync } from 'shared/store/actions/user/sections'

import { GlobalStore as store } from '@driftt/traffic-control'

export const fetchSectionSubscriptions = () => {
  store.dispatch(fetchSectionsSubscriptionsAsync.request())
  getNotificationsBySection()
    .then((notifications) => {
      store.dispatch(fetchNotificationSettingsBySubscription(notifications))
      store.dispatch(fetchSectionsSubscriptionsAsync.success(notifications))
    })
    .catch((err) => {
      store.dispatch(fetchSectionsSubscriptionsAsync.failure(err))
    })
}

export default function useBootstrap() {
  const orgId = useSelector(getOrgId)
  const dispatch = useDispatch()

  useEffect(() => {
    fetchBans().then((bans) => {
      dispatch(fetchBansAsync.success(bans))
    })

    fetchBootstrap().then((bootstrap) => {
      dispatch(fetchBootstrapAsync.success(bootstrap))
    })

    fetchTeams().then((teams) => {
      dispatch(fetchTeamsAsync.success(teams))
    })

    fetchRules().then((rules) => {
      dispatch(fetchRulesAsync.success(rules))
    })

    fetchPreferences().then((preferences) => {
      dispatch(fetchPreferencesAsync.success(preferences))
    })

    fetchSectionSubscriptions()
  }, [dispatch])

  useEffect(() => {
    if (orgId) {
      fetchUsers(orgId).then((users) => {
        dispatch(fetchUsersAsync.success(users))
      })

      fetchTags(orgId).then((tags) => {
        dispatch(fetchTagsAsync.success(tags))
      })
    }
  }, [orgId, dispatch])
}
